module.exports = __webpack_public_path__ + "media/reskin-images/icon--gift-f00aa20e.svg";